import { render, staticRenderFns } from "./SettingsAccount.vue?vue&type=template&id=f7262362&scoped=true&lang=pug&"
import script from "./SettingsAccount.vue?vue&type=script&lang=js&"
export * from "./SettingsAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7262362",
  null
  
)

export default component.exports